"use client";

import { motion } from "motion/react";
import { cn } from "@/lib/utils";
import Image from "next/image";
import { InfoCard } from "./InfoCard";
import { Flash } from "@/components/icons/Flash";
import { Payment } from "@/components/icons/Payment";
import { TransferCart } from "@/components/icons/TransferCart";
import { DiscountPercentFire } from "@/components/icons/DiscountPercentFire";
import {
  slideUpVariants,
  staggerContainerVariants,
  slideFromLeftVariants,
  slideFromRightVariants,
  fadeInVariants,
} from "@/lib/animations";

function ImageCard({ className }: { className?: string }) {
  return (
    <div className={cn(className)}>
      <Image
        src="/assets/images/app-shot-2.webp"
        alt="device"
        width={390}
        height={577}
        className="w-full object-contain"
        sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 25vw"
      />
    </div>
  );
}

export function Device() {
  return (
    <section
      id="device"
      className="bg-green-gradient-2 p-5 md:px-6 md:pt-8 lg:px-10 lg:pb-0 lg:pt-10"
    >
      <div className="mx-auto max-w-5xl">
        <motion.h2
          className="mb-10 text-center text-2xl font-medium tracking-copy sm:text-3xl md:mb-12 md:text-4xl lg:mb-16 lg:text-5xl lg:leading-[1.18] 2xl:mb-20"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={slideUpVariants}
        >
          Get your first device from Pluck
        </motion.h2>

        <motion.div
          className="grid grid-cols-1 gap-5 lg:grid-cols-3 lg:gap-10"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          variants={staggerContainerVariants}
        >
          <motion.div
            className="flex flex-col gap-5 md:flex-row lg:flex-col lg:gap-10"
            variants={slideFromLeftVariants}
          >
            <InfoCard
              icon={Flash}
              title="Instant Access"
              description="Make a deposit and instantly take home the latest smartphone."
            />
            <InfoCard
              icon={Payment}
              title="Pay Easy"
              description="Make easy daily, weekly or monthly payments."
              className="lg:relative lg:-left-5 xl:-left-10"
            />
          </motion.div>

          <motion.div className="hidden lg:block" variants={fadeInVariants}>
            <ImageCard />
          </motion.div>

          <motion.div
            className="flex flex-col gap-5 md:flex-row lg:flex-col lg:gap-10"
            variants={slideFromRightVariants}
          >
            <InfoCard
              icon={TransferCart}
              title="Own Easy"
              description="Own any device and build a credit history with Pluck for future deals."
            />
            <InfoCard
              icon={DiscountPercentFire}
              title="Upgrade"
              description="Unlock access to a wider range of Pluck products and services."
              className="lg:relative lg:-right-5 xl:-right-10"
            />
          </motion.div>
        </motion.div>

        <motion.div
          className="mx-auto mt-16 block max-w-xs lg:hidden"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeInVariants}
        >
          <ImageCard />
        </motion.div>
      </div>
    </section>
  );
}
